const headerCls = "_275h6dpv4n";
const tablistWrapperCls = "_275t1d0zuwa";
const tabsCls = "_275tckcj22";
const tabListTitle = "_275t193qid1";
const searchCls = "_275s1vm5bup";
const tabToggleNotificationBadge = "_275t19xj7d8";

export { headerCls, searchCls, tabListTitle, tabToggleNotificationBadge, tablistWrapperCls, tabsCls };
import "./topbar.teacher.style.linaria.module.css";
//# sourceMappingURL=topbar.teacher.style.js.map
